var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIndexMappingAdd = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.5,14c-.8,0-1.5-.7-1.5-1.5v-4.5h-3.1c-.2.6-.8,1-1.4,1s-1.5-.7-1.5-1.5.7-1.5,1.5-1.5,1.2.4,1.4,1h3.1V2.5c0-.8.7-1.5,1.5-1.5h2.6c.2-.6.8-1,1.4-1s1.5.7,1.5,1.5-.7,1.5-1.5,1.5-1.2-.4-1.4-1h-2.6c-.3,0-.5.2-.5.5v10c0,.3.2.5.5.5M3.5,3c-.8,0-1.5-.7-1.5-1.5s.7-1.5,1.5-1.5,1.5.7,1.5,1.5-.7,1.5-1.5,1.5ZM3.5,15c-.8,0-1.5-.7-1.5-1.5s.7-1.5,1.5-1.5,1.5.7,1.5,1.5-.7,1.5-1.5,1.5ZM13.5,9c-.8,0-1.5-.7-1.5-1.5s.7-1.5,1.5-1.5,1.5.7,1.5,1.5-.7,1.5-1.5,1.5Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5,7c-2.5,0-4.5,2-4.5,4.5s2,4.5,4.5,4.5,4.5-2,4.5-4.5-2-4.5-4.5-4.5ZM14,12h-2v2h-1v-2h-2v-1h2v-2h1v2h2v1Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIndexMappingAdd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/indexMappingAdd.37f793c9a2c23babfb694190323d5730.svg";